"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisV } from "@instadeepai/fontawesome-pro-regular"

import { Avatar, AvatarFallback, AvatarImage } from "@shared/ui"

interface UserFooterProps {
  firstName: string
  lastName: string
  imageSrc?: string
}

export const UserFooter = ({
  firstName,
  lastName,
  imageSrc,
}: UserFooterProps) => {
  return (
    <div className="flex h-10 items-center justify-between gap-2 px-1 py-2.5">
      <div className="flex cursor-pointer items-center gap-2">
        <Avatar className="size-8">
          {imageSrc ? (
            <AvatarImage src={imageSrc} alt={`${firstName} ${lastName}`} />
          ) : (
            <AvatarFallback>
              {firstName[0]}
              {lastName[0]}
            </AvatarFallback>
          )}
        </Avatar>
        <span className="text-[14px] font-semibold leading-[18px] text-[#EDEEF1]">
          {firstName} {lastName}
        </span>
      </div>
      <button className="text-[#A5A6F6] transition-colors hover:text-[#EDEEF1]">
        <FontAwesomeIcon icon={faEllipsisV} className="text-[14px]" />
      </button>
    </div>
  )
}
